import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  TenantFilterCell,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  setDateRangeFilter,
  GridDateCell,
  GridDateTimeCell,
}) => {
  const dataColumns = [
    {
      field: 'row_no',
      title: 'Row No',
      editable: false,
      show: false,
      width: '250px',
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'uc_ossi_run_set_grp_seq',
      title: 'Run Set Group Sequence',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_run_set_grp_id',
      title: 'Run Set Group ID',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },    
    {
      field: 'uc_ossi_run_seq',
      title: 'Run Set Sequence',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },    
    {
      field: 'uc_ossi_run_set_run_id',
      title: 'Run Set Id',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'tenant_name',
      title: 'Tenant',
      editable: false,
      show: false,
      width: '200px',
      minResizableWidth: 150,
      ...(TenantFilterCell
        ? {
            filterCell: (props) =>
              TenantFilterCell({
                ...props,
                filterType: 'dropdown',
              }),
          }
        : {}),
    },
    {
      field: 'uc_ossi_prod_id',
      title: 'Prod Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
    },

    {
      field: 'exec_typ_cd',
      title: 'Execution Type CD',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'exec_invoke_method_cd',
      title: 'Execution Invoke Method',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_run_set_test_case_id',
      title: 'Run Set TestCase Id',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_run_set_status',
      title: 'Run Set Status',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_run_set_exec_ms',
      title: 'Run Set Execution (In Milliseconds)',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_run_set_start_dt',
      title: 'Start Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      ...(MultiViewCalenderFilterCell
        ? {
            filterCell: (props) =>
              MultiViewCalenderFilterCell({
                ...props,
                dateRangefilter: dateRangeFilter,
                setDateRangeFilter,
                field: 'uc_ossi_run_set_start_dt',
              }),
          }
        : {}),
      isRequired: true,
      cell: GridDateTimeCell,
    },
    {
      field: 'uc_ossi_run_set_end_dt',
      title: 'End Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      ...(MultiViewCalenderFilterCell
        ? {
            filterCell: (props) =>
              MultiViewCalenderFilterCell({
                ...props,
                dateRangefilter: dateRangeFilter,
                setDateRangeFilter,
                field: 'uc_ossi_run_set_end_dt',
              }),
          }
        : {}),
      isRequired: true,
      cell: GridDateTimeCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
